module.exports = __webpack_public_path__ + "designmodo.jpg?4746e67ebd0fae869fc5106f30ce41b8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/designmodo.jpg
// module id = 55
// module chunks = 0